import {listLanguage} from "../../crud/language.crud";
import {put, takeLatest} from "redux-saga/effects";
export const actionTypes = {
    LANGUAGE_ADDED: "LANGUAGE_ADDED",
    LANGUAGE_ADDED_SUCCESS: "LANGUAGE_ADDED_SUCCESS",
    LANGUAGE_UPDATED: "LANGUAGE_UPDATED",
    LANGUAGE_UPDATED_SUCCESS: "LANGUAGE_UPDATED_SUCCESS"
};

const initialAuthState = {
    listData: undefined
};

export const reducer = (state = initialAuthState, action) => {
    switch (action.type) {
        case actionTypes.LANGUAGE_ADDED_SUCCESS:
            {
                const {listData} = action.payload;
                return {listData};
            }
        case actionTypes.LANGUAGE_UPDATED_SUCCESS:
            {
                const {listData} = action.payload;
                return {listData};
            }
        default:
            return state;
    }
};

export const actions = {
    languageAdded: ({skip, limit}) => ({
        type: actionTypes.LANGUAGE_ADDED,
        payload: {
            skip,
            limit
        }
    }),
    languageUpdated: ({skip, limit}) => ({
        type: actionTypes.LANGUAGE_UPDATED,
        payload: {
            skip,
            limit
        }
    })
};

export function * saga() {
    yield takeLatest(actionTypes.LANGUAGE_ADDED, function * languageAdded(action) {
        const {skip, limit} = action.payload;
        const listData = yield listLanguage({skip, limit});

        yield put({type: actionTypes.LANGUAGE_ADDED_SUCCESS, payload: {
                listData
            }});
    });

    yield takeLatest(actionTypes.LANGUAGE_UPDATED, function * languageUpdated(action) {
        const {skip, limit} = action.payload;
        const listData = yield listLanguage({skip, limit});

        yield put({type: actionTypes.LANGUAGE_UPDATED_SUCCESS, payload: {
                listData
            }});
    });
}
